import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/** Runs available zone connectors and presents each independent result. */
@ngCore.Component({
  imports: [
    ngCommon.DatePipe,
    ds.button.Component,
    ds.input.checkbox.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-integration-run-dialog',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Entity utilities used directly by the template. */
  public readonly Ents = ents

  /** Connector collection and its child run feature for the active app zone. */
  public readonly connectorsEc = ngCore.inject(
    state.integrations.connectors.Collection,
  )

  /** Connector definitions used to display the selected definition name. */
  public readonly definitionsEc = ngCore.inject(
    state.integrations.connectorDefinitions.Collection,
  )

  /** Returns the connector's selected definition. */
  public getDefinition(
    definitions: readonly ents.core.integrations.Connector.Definition[],
    definitionId: ents.core.integrations.Connector.Definition.Id,
  ): ents.core.integrations.Connector.Definition | undefined {
    return definitions.find(definition => definition.id === definitionId)
  }
}
